import { render, staticRenderFns } from "./ItemRefundReasons.vue?vue&type=template&id=cb17b552&scoped=true&"
import script from "./ItemRefundReasons.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ItemRefundReasons.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ItemRefundReasons.vue?vue&type=style&index=0&id=cb17b552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb17b552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb17b552')) {
      api.createRecord('cb17b552', component.options)
    } else {
      api.reload('cb17b552', component.options)
    }
    module.hot.accept("./ItemRefundReasons.vue?vue&type=template&id=cb17b552&scoped=true&", function () {
      api.rerender('cb17b552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Refund/ItemRefundReasons.vue"
export default component.exports